// 'use strict';
// (function () {
//   const adLogin = {
//     templateUrl: 'app/auth/login/login.html',
//     controller
//   };

//   controller.$inject = ['$log', 'adalAuthenticationService', '$scope', 'Auth'];

//   function controller($log, ADAL, scope, Auth) {
//     const self = this;

//     self.user = {};

//     self.login = function () {
//       ADAL.login();
//     };

//     $log.log(ADAL);
//     // ADAL.updateDataFromCache().then(data => {
//     //   $log.log(data);
//     // });

//     // can pass data to callback
//     scope.$on('adal:loginSuccess', () => {
//       const adUid = ADAL.userInfo.profile;
//       $log.log(adUid);

//       Auth.$signInWithCustomToken(adUid)
//         .then(firebaseUser => {
//           $log.log('Signed in as:', firebaseUser.uid);
//         }).catch(error => {
//           $log.error('Authentication failed:', error);
//         });
//     });
//   }

//   angular
//     .module('app')
//     .component('adLogin', adLogin);
// })();
"use strict";

var cov_2bst73kkjr = function () {
  var path = "/Users/ryanluton/Developer/divcon/divcon-tools/src/app/common/auth/login/ad-login.js",
      hash = "1d080ff4315af152b564b83b39040b38290d98b3",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/ryanluton/Developer/divcon/divcon-tools/src/app/common/auth/login/ad-login.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();